"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaloriesBudgetTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const form_1 = require("../../atoms/form");
const table_1 = require("../../molecules/table");
const react_i18next_1 = require("react-i18next");
const icons_1 = require("../../atoms/icons");
const hooks_1 = require("../../shared/hooks");
const toggle_1 = require("../../atoms/toggle");
const buttons_1 = require("../../atoms/buttons");
const hooks_2 = require("../../shared/hooks");
const CaloriesBudgetTable = ({ nutritionValues, unitOfMeasure, isSecured, isForTrainingDay, isLastCaloriesBudget, onChange, onIsSecureChange, onSubmitCalorieBudget }) => {
    const { isOffline } = (0, hooks_1.useNetwork)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const [facts, setFacts] = (0, react_1.useState)(nutritionValues);
    const { isMobile } = (0, hooks_2.useRWD)();
    // TODO: TS - Remove translation types casting
    const mobileTranslations = t("memberDetailsTranslations.calorieBudget.units", {
        returnObjects: true
    });
    const directNutrientsUpdate = (budget) => {
        setFacts(budget);
    };
    const onNutrientChange = (e) => {
        const { name, value } = e.target;
        const numberValue = value === "" ? 0 : parseInt(value);
        if (isNaN(numberValue))
            return;
        const newFacts = { ...facts, [name]: numberValue };
        setFacts(newFacts);
        onChange(newFacts, directNutrientsUpdate);
    };
    const handleIsSecuredChange = (e) => {
        onIsSecureChange(e.target.checked);
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isMobile ? ((0, jsx_runtime_1.jsxs)(Mobile, { children: [(0, jsx_runtime_1.jsxs)(table_1.Table, { children: [(0, jsx_runtime_1.jsx)(OfflineInfo, { isOffline: isOffline }, void 0), (0, jsx_runtime_1.jsx)(table_1.TableHeader, { children: `${t(`memberDetailsTranslations.calorieBudget.tableHeaders.${isForTrainingDay ? "trainingsDay" : "nonTrainingsDay"}`)}` }, void 0), Object.entries(facts).map(([key, value]) => {
                            return ((0, jsx_runtime_1.jsxs)(table_1.TableRow, { children: [(0, jsx_runtime_1.jsx)(table_1.TableCell, { children: (0, jsx_runtime_1.jsx)(typography_1.P, { children: key === "calories"
                                                ? t("memberDetailsTranslations.calorieBudget.total")
                                                : mobileTranslations[key] }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(table_1.TableCell, { children: (0, jsx_runtime_1.jsx)(form_1.Input, { disabled: key === "calories" || isOffline, value: value + "", onChange: onNutrientChange, name: key }, void 0) }, void 0), (0, jsx_runtime_1.jsx)(table_1.TableCell, { children: (0, jsx_runtime_1.jsx)(typography_1.P, { className: key === "calories" ? "calories" : "", children: unitOfMeasure }, void 0) }, void 0)] }, key));
                        })] }, void 0), isLastCaloriesBudget && ((0, jsx_runtime_1.jsxs)(BottomSection, { children: [(0, jsx_runtime_1.jsxs)(SecuredCheckboxWrapper, { children: [(0, jsx_runtime_1.jsx)(toggle_1.Checkbox, { checked: isSecured, disabled: isOffline, label: t("memberDetailsTranslations.calorieBudget.checkboxLabel"), onChange: handleIsSecuredChange }, void 0), isSecured && ((0, jsx_runtime_1.jsx)(typography_1.P, { children: t("memberDetailsTranslations.calorieBudget.isPinnedExplanation") }, void 0))] }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "primary", onClick: onSubmitCalorieBudget, disabled: isOffline, children: t("memberDetailsTranslations.calorieBudget.button") }, void 0)] }, void 0))] }, void 0)) : ((0, jsx_runtime_1.jsxs)(Desktop, { children: [!isLastCaloriesBudget && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isOffline && ((0, jsx_runtime_1.jsx)(OfflineInfo, { className: "offline", isOffline: isOffline }, void 0)), (0, jsx_runtime_1.jsxs)(Header, { children: [(0, jsx_runtime_1.jsx)("p", { children: t(`memberDetailsTranslations.calorieBudget.generalTitle`) }, void 0), Object.keys(nutritionValues).map((nutritionKey) => ((0, jsx_runtime_1.jsx)("p", { children: t(`historyOfChanges.budget.${nutritionKey}`) }, nutritionKey)))] }, void 0)] }, void 0)), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("p", { children: `${t(`memberDetailsTranslations.calorieBudget.tableHeaders.${isForTrainingDay ? "trainingsDay" : "nonTrainingsDay"}`)}
              ` }, void 0), Object.entries(facts).map(([key, value]) => {
                            return ((0, jsx_runtime_1.jsxs)(InputWrapper, { children: [(0, jsx_runtime_1.jsx)(form_1.Input, { disabled: key === "calories" || isOffline, value: value + "", onChange: onNutrientChange, name: key }, void 0), key !== "calories" && (0, jsx_runtime_1.jsx)(typography_1.P, { children: unitOfMeasure }, void 0)] }, key));
                        })] }, void 0), isLastCaloriesBudget && ((0, jsx_runtime_1.jsxs)("div", { className: "bottomSection", children: [(0, jsx_runtime_1.jsx)("div", {}, void 0), (0, jsx_runtime_1.jsx)(BottomSectionWrapper, { children: (0, jsx_runtime_1.jsxs)(BottomSection, { children: [(0, jsx_runtime_1.jsxs)(SecuredCheckboxWrapper, { children: [(0, jsx_runtime_1.jsx)(toggle_1.Checkbox, { checked: isSecured, disabled: isOffline, label: t("memberDetailsTranslations.calorieBudget.checkboxLabel"), onChange: handleIsSecuredChange }, void 0), isSecured && ((0, jsx_runtime_1.jsx)(typography_1.P, { "data-testid": "budgetExplanation", children: t("memberDetailsTranslations.calorieBudget.isPinnedExplanation") }, void 0))] }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "primary", onClick: onSubmitCalorieBudget, disabled: isOffline, children: t("memberDetailsTranslations.calorieBudget.button") }, void 0)] }, void 0) }, void 0)] }, void 0))] }, void 0)) }, void 0));
};
exports.CaloriesBudgetTable = CaloriesBudgetTable;
const OfflineInfo = ({ isOffline, className }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return isOffline ? ((0, jsx_runtime_1.jsxs)(OfflineInfoWrapper, { className: className, children: [(0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangleSmall", icon: ["fal", "info-circle"], color: "yellow" }, void 0), (0, jsx_runtime_1.jsxs)(typography_1.P, { children: [t("memberDetailsTranslations.calorieBudget.offlineLabel.label"), "\u00A0", (0, jsx_runtime_1.jsx)("span", { children: t("memberDetailsTranslations.calorieBudget.offlineLabel.link") }, void 0)] }, void 0)] }, void 0)) : null;
};
const Mobile = styled_components_1.default.div `
  background: ${({ theme }) => theme.colors.whiteBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  padding: ${({ theme }) => theme.spacings.m};
  width: 100%;

  table {
    width: 100%;
  }

  th {
    display: block;
    font-weight: 600;
    padding-bottom: ${({ theme }) => theme.spacings.m};
    padding-right: 0;
    min-width: 35%;
  }

  tr {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0;
  }

  tr:first-of-type {
    flex-wrap: wrap;
    flex-direction: row;
    align-items: flex-start;
  }

  tr td:first-of-type {
    flex: 2;
    width: auto;
    font-weight: 400;
  }

  tr:first-of-type td:first-of-type {
    display: flex;
    justify-content: flex-start;
    padding-right: ${({ theme }) => theme.spacings.m};
  }

  tr:first-of-type td:last-of-type {
    display: flex;
  }

  td {
    align-items: center;
    display: flex;
    margin-bottom: ${({ theme }) => theme.spacings.xs};
    padding: 0;
  }

  td p {
    margin: 0;
  }

  td:first-of-type p::first-letter {
    text-transform: uppercase;
  }

  td input {
    font-size: 0.75rem;
    height: 100%;
    padding: ${({ theme }) => `${theme.spacings.xxs} 0`};
    text-align: center;
    width: 3.125rem;
  }

  tr td:nth-of-type(2) {
    flex: 0;
  }

  tr td:last-of-type {
    justify-self: flex-start;
    padding-left: ${({ theme }) => theme.spacings.m};
  }

  tr:first-of-type .caloriesCell {
    padding-left: 1rem;
  }

  .calories {
    visibility: hidden;
  }
`;
const Desktop = styled_components_1.default.div `
  > div:not(.offline) {
    display: flex;
    align-items: center;
    padding-bottom: ${({ theme }) => theme.spacings.s};

    > p:first-child,
    > div:first-child {
      flex: 3;
    }

    > p,
    > div {
      flex: 1;
    }
  }

  .offline {
    width: 100%;
    justify-content: center;
    padding-bottom: ${({ theme }) => theme.spacings.s};
  }

  div:last-child div {
    display: flex;
  }

  p {
    margin-bottom: 0;
  }

  .bottomSection {
    padding-bottom: 0 !important;
  }
`;
const OfflineInfoWrapper = styled_components_1.default.div `
  align-items: center;
  display: inline-flex;
  justify-content: center;

  p {
    color: ${({ theme }) => theme.colors.yellowBase};
    padding-left: ${({ theme }) => theme.spacings.xxs};
    margin-bottom: 0;
  }

  span {
    text-decoration: underline;
  }
`;
const BottomSectionWrapper = styled_components_1.default.div `
  &&&& {
    flex: 4;
    justify-content: space-between;
    padding-bottom: 0 !important;
  }
`;
const BottomSection = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;

  button {
    font-size: 0.75rem;
    margin-top: ${({ theme }) => theme.spacings.m};
    width: 5rem;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    margin-left: auto;
  }
`;
const SecuredCheckboxWrapper = styled_components_1.default.div `
  flex-direction: column;

  & > div:first-of-type {
    margin-bottom: 0;

    label > h4 {
      font-weight: 400;
    }
  }

  & > p {
    font-size: ${({ theme }) => theme.spacings.s};
    margin: ${({ theme }) => `${theme.spacings.xxs} 0 0`};
  }
`;
const Header = styled_components_1.default.div `
  font-weight: bold;
`;
const InputWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacings.s};

  input {
    width: 3rem;
    height: 1.5rem;
    padding: ${({ theme }) => theme.spacings.xs};
    font-size: ${({ theme }) => theme.spacings.s};
  }
`;
//# sourceMappingURL=CaloriesBudgetTable.js.map